// ============================================================
// Novala i18n Configuration
// Sets up react-i18next with browser language detection.
// Supported languages: English (en), French (fr).
// Add new languages: create locales/<code>.json and import here.
// ============================================================

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', native: 'Français' },
  { code: 'fr', label: 'French', native: 'Français' },
] as const;

export const DEFAULT_LANGUAGE = 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES.map(l => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupCookie: 'NEXT_LOCALE',
      lookupLocalStorage: 'novala_language',
      cookieDomain: typeof window !== 'undefined' && window.location.hostname.endsWith('getnovala.com') ? '.getnovala.com' : undefined,
      cookieMinutes: 60 * 24 * 365,
    },
    react: { useSuspense: false },
  });

export default i18n;
